import Cookies from 'js-cookie'
import {COOKIE_DOMAIN} from './index'
// const isDev = process.env.NODE_ENV === 'development'

// const isProd = process.env.NODE_ENV === 'production'

const config = {
  // domain: isDev ? 'localhost' : isProd ? 'yoyohr.com' : 'youpin-k8s.net'
  domain: COOKIE_DOMAIN
}

export default {
  get (key) {
    return Cookies.get(key, config)
  },
  set (key, value) {
    Cookies.set(key, value, Object.assign({ expires: 1 }, config))
  },
  remove (key) {
    Cookies.remove(key, config)
  }
}



// WEBPACK FOOTER //
// ./src/config/cookie.js